import React, { useState } from 'react';
import {
	Box, ListItemIcon, Menu, MenuItem
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import PropTypes from 'prop-types';
import './MenuDropdown/menu.m.css';

function InventoryMenu({
	handleClose = () => {},
	kebabMenuItem = [],
	handleClick = () => {},
	isBranchTab = false
}) {
	const [anchorEl, setAnchorEl] = useState(null);
	const open = Boolean(anchorEl);

	const handleMenuClick = (event) => {
		setAnchorEl(event.currentTarget);
	};

	const handleItemClick = (item) => {
		handleClick(item);
		setAnchorEl(null);
		handleClose();
	};

	return (
		<>
			<MoreVertIcon
				onClick={handleMenuClick}
				sx={{ cursor: 'pointer', color: '#21241E', opacity: '0.2' }}
			/>
			<div className='menudropdown-wrapper'>
				{kebabMenuItem.length > 0 && (
					<Menu
						anchorEl={anchorEl}
						open={open}
						sx={{
							boxShadow: '0px 0px 0px transparent',
							mt: '1px',
							'& .MuiMenu-paper': { paddingRight: '0px' }
						}}
						onClose={() => {
							setAnchorEl(null);
						}}
					>
						{kebabMenuItem.map((val, index) => (
							<MenuItem
								key={'a' + index}
								onClick={() => {
									if (isBranchTab) {
										handleItemClick(val);
									} else {
										handleItemClick(val.value);
									}
								}}
							>
								<ListItemIcon>
									<val.icon />
								</ListItemIcon>

								<Box sx={{ color: '#0A0909' }}>{val.title}</Box>
							</MenuItem>
						))}
					</Menu>
				)}
			</div>
		</>
	);
}

export default InventoryMenu;

InventoryMenu.propTypes = {
	handleClose: PropTypes.any,
	kebabMenuItem: PropTypes.any,
	handleClick: PropTypes.any,
	isBranchTab: PropTypes.any
};
